import { fork, all } from "redux-saga/effects";
import appointmentStepSagas from "./appointmentStep";
import appointmentAdvancedStep from "./appointmentAdvancedStep";
import customerRecentAppointmentSagas from "./customerRecentAppointment";
import checkoutAppointmentSagas from "./checkoutAppointmentStep";
import customerProfileSagas from "./customerProfile";
import customerNotesSagas from "./customerNotes";
import bookingSagas from "./booking";
import waitlistSagas from "./waitlist";
const sagas = [
  ...appointmentStepSagas,
  ...bookingSagas,
  ...customerRecentAppointmentSagas,
  ...customerNotesSagas,
  ...customerProfileSagas,
  ...checkoutAppointmentSagas,
  ...appointmentAdvancedStep,
  ...waitlistSagas
  //, ...moreSagas
];

export default function* root() {
  //this function is being run by sagaMiddleware.run
  yield all(sagas.map(saga => fork(saga)));
}
